import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { GET_SUBSCRIPTION_AUTO_APPLY_COUPON_CACHE } from '../gql/queries';
import { APOLLO_COMMERCE_CONTEXT } from '../gql/constants';
import { captureError, Severity, TeamInfo } from '@chegg/observability';
import { ErrorLocations } from '../common/interfaces';
/**
 * Queries getSubscriptionAutoApplyCouponCache and returns the first cached coupon code.
 *
 * This util is isomorphic, so it can be called server-side or client-side.
 */
var getCachedCoupon = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apolloClient, currency, planCode, uuid, _data$subscriptionAut, _yield$apolloClient$q, data;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          apolloClient = _ref.apolloClient, currency = _ref.currency, planCode = _ref.planCode, uuid = _ref.uuid;
          if (planCode) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", undefined);
        case 3:
          _context2.prev = 3;
          _context2.next = 6;
          return apolloClient.query({
            query: GET_SUBSCRIPTION_AUTO_APPLY_COUPON_CACHE,
            variables: {
              input: {
                currency: currency,
                planCode: planCode
              }
            },
            context: _defineProperty({
              headers: {
                'X-CHEGG-USER-UUID': uuid
              }
            }, APOLLO_COMMERCE_CONTEXT, true)
          });
        case 6:
          _yield$apolloClient$q = _context2.sent;
          data = _yield$apolloClient$q.data;
          return _context2.abrupt("return", data === null || data === void 0 || (_data$subscriptionAut = data.subscriptionAutoApplyCouponCache) === null || _data$subscriptionAut === void 0 || (_data$subscriptionAut = _data$subscriptionAut.couponCache) === null || _data$subscriptionAut === void 0 || (_data$subscriptionAut = _data$subscriptionAut[0]) === null || _data$subscriptionAut === void 0 ? void 0 : _data$subscriptionAut.couponCode);
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](3);
          captureError({
            error: _context2.t0,
            severity: Severity.CRITICAL,
            location: ErrorLocations.QUERY_CACHED_COUPON
          }, {
            UserUuid: uuid,
            teamName: TeamInfo['FT-CommerceWeb'].name
          });
          return _context2.abrupt("return", undefined);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[3, 11]]);
  }));
  return function getCachedCoupon(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default getCachedCoupon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getCachedCoupon.js
// module id = 4169
// module chunks = 11